module.exports = __webpack_public_path__ + "img/amsFA2.9e1492b4.png";